export const vitalStackCodes = {
  owned: "owned",
  list: "list",
  item: "item",
};

export const defaultStackItem = {
  code: vitalStackCodes.owned,
};
